import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Box, Flex, useTheme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { IHeaderParams } from 'ag-grid-community';

import { ArrowDown1, ArrowUp1 } from 'assets/assetsV1/iconComponents';
import { ColumnFilter } from 'assets/assetsV1/iconComponents/ColumnFilter';
import { ColumnFilterActive } from 'assets/assetsV1/iconComponents/ColumnFilterActive';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

const StyledFilterIconContainer = styled(Box)`
  svg {
    height: 24px;
    width: 24px;
  }
  &:hover {
    svg {
      color: ${(props) => props.theme.colors.icon['1565BC']};
    }
  }
`;

export type AgGridHeaderProps = IHeaderParams & {
  isGroupHeader?: boolean;
};

export const AgGridHeader: React.FC<AgGridHeaderProps> = (props) => {
  const theme = useTheme();
  const [currentSort, setCurrentSort] = useState<'asc' | 'desc'>(null);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const refButton = useRef(null);

  const onMenuClicked = () => {
    props.showColumnMenu(refButton.current);
  };

  const onSortClicked = (event: React.MouseEvent<HTMLDivElement>) => {
    // in this example, we do multi sort if Shift key is pressed
    if (props.enableSorting) props.progressSort(event.shiftKey);
  };

  const onSortChanged = useCallback(() => {
    const sort = props.column.getSort();
    setCurrentSort(sort);
  }, [props.column]);

  useEffect(() => {
    props.column?.addEventListener('sortChanged', onSortChanged);
    return () => {
      props.column?.removeEventListener('sortChanged', onSortChanged);
    };
  }, [onSortChanged, props.column]);

  let menu = null;
  if (props.enableMenu) {
    menu = (
      <StyledFilterIconContainer ref={refButton} className="customHeaderMenuButton" onClick={onMenuClicked}>
        {isFilterActive ? (
          <ColumnFilterActive color={theme.colors.icon['1565BC']} />
        ) : (
          <ColumnFilter color={theme.colors.text.g2} />
        )}
      </StyledFilterIconContainer>
    );
  }

  let sort = null;
  if (props.enableSorting) {
    sort = (
      <div style={{ display: 'inline-block' }}>
        {currentSort === 'asc' && <ArrowUp1 color={theme.colors.text.g1} />}
        {currentSort === 'desc' && <ArrowDown1 color={theme.colors.text.g1} />}
      </div>
    );
  }

  useEffect(() => {
    const callbackFunction = function () {
      setIsFilterActive(props.column.isFilterActive());
    };

    props.column?.addEventListener('filterChanged', callbackFunction);
    return () => {
      props.column?.removeEventListener('filterChanged', callbackFunction);
    };
  }, [props.column]);

  return (
    <Flex alignItems="center" justifyContent="space-between" width="100%">
      <Flex
        flex={1}
        alignItems="center"
        justifyContent={props.isGroupHeader ? 'center' : 'flex-start'}
        onClick={onSortClicked}
      >
        <TextBodyMedium color={theme.colors.text.g1}>{props.displayName}</TextBodyMedium>
        {sort}
      </Flex>
      {menu}
    </Flex>
  );
};
